
export enum Urls {
    LOGIN = '/auth/login',
    REGISTER = '/auth/register',
    ME = '/auth/me',
    CATEGORY_CREATE = '/categories/create',
    CATEGORY_UPDATE = '/categories/update',
    CATEGORY_DELETE = '/categories/delete',
//     all categories
    CATEGORIES = '/categories/all',

    PRODUCT_CREATE = '/products/add',
    PRODUCT_UPDATE = '/products/update',
    UPDATE_CHARACTER = '/products/update/character',
//     product filter
    PRODUCTS_FILTER = '/products/filter',
    PRODUCT_GET = '/products/get/',
    GENERATE_CODE = '/products/code',

    CLIENT_CREATE = '/clients/create',
    CLIENT_UPDATE = '/clients/update',
    CLIENT_FILTER = '/clients/filter',
    CLIENT_SEARCH = '/clients/get?search=',

    ORGANIZATION_CREATE = '/organization/create',
    ACCOUNTANT_CREATE = '/organization/accountant',
    EMPLOYEE_CREATE = '/organization/employee',
    ORGANIZATION_FILTER = '/organization/filter',
    ORGANIZATION_GET = '/organization/',
    ORGANIZATION_UPDATE = '/organization/update',

    ORDER_CREATE = '/orders/create',
    ORDER_DELETE = '/orders/delete/',
    ORDER_ALL = '/orders/all',
    ORDER_BY_CLIENT = '/orders',
    ORDERS = '/orders',

    // Unit Types
    UNIT_TYPES = '/unit-types',

    // Branches
    BRANCH_CREATE = '/v0/branches',
    BRANCH_UPDATE = '/v0/branches',
    BRANCH_DELETE = '/v0/branches',
    BRANCH_HIERARCHY = '/v0/branches/hierarchy',
    BRANCH_ACCESSIBLE = '/v0/branches/accessible',
    BRANCH_GET = '/v0/branches',
    BRANCH_ACCESSIBLE_IDS = '/v0/branches/accessible-ids',

    // Admin APIs
    ADMIN_USERS = '/v0/admin/users',
    ADMIN_USERS_SEARCH = '/v0/admin/users/search',
    ADMIN_ORGANIZATIONS = '/v0/admin/organizations',
    ADMIN_ORGANIZATIONS_SEARCH = '/v0/admin/organizations/search',
    ADMIN_BRANCHES = '/v0/admin/branches',
    ADMIN_INITIALIZE_BRANCH_ASSIGNMENTS = '/v0/admin/initialize-branch-assignments',

}
